import React from "react"
import { render } from "react-dom"
import { AppContainer } from "react-hot-loader"
import ReactModal from "react-modal"
import configStore from "./common/configStore"
import routeConfig from "./common/routeConfig"
import Root from "./Root"

ReactModal.setAppElement(document.getElementById("root"))

const store = configStore()

function renderApp(app) {
  render(<AppContainer>{app}</AppContainer>, document.getElementById("root"))
}

renderApp(<Root store={store} routeConfig={routeConfig} />)

// Hot Module Replacement API
/* istanbul ignore if  */
if (module.hot) {
  module.hot.accept("./common/routeConfig", () => {
    const routeConfig = require("./common/routeConfig").default // eslint-disable-line
    renderApp(<Root store={store} routeConfig={routeConfig} />)
  })
  module.hot.accept("./Root", () => {
    const Root = require("./Root").default // eslint-disable-line
    renderApp(<Root store={store} routeConfig={routeConfig} />)
  })
}



// WEBPACK FOOTER //
// ./src/index.js